export default __webpack_public_path__ + "static/media/leader_notes_detailed.80a5f8cc.pdf";